const US_REGION = 'US';
const NON_US_REGION = 'nonUs';

export {
    US_REGION,
    NON_US_REGION
};
